const HeaderView = () => {
    return(
        <div className="row">
            <div className="row">
                <div className="col-md-12">
                    <h6 className="text-white text-capitalize ps-3">ALL DISPUTES</h6> 
                </div>
            </div>
        </div>
    );
}

export default HeaderView;